import React, { useMemo, useState } from "react";
import {
  MimaButton,
  MimaDropdown,
  MimaMultiDropdown,
  MimaText,
  MimaToastUtil,
  PageLoader,
} from "../../components";
import styles from "../../assets/styles/Settings/Settings.module.scss";
import { Formik } from "formik";
import * as yup from "yup";
import { WalletController } from "../../controllers";
import constant from "../../utils/constant";

const Provider = () => {
  const [loading, setLoading] = useState(false);
  const { isLoading, data } = WalletController.useGetNGNProviders();
  const banksData = WalletController.useGetBanks();

  const banks = useMemo(() => {
    if (banksData?.data?.status === constant.Success) {
      return (
        banksData?.data?.data.banks.map((bank) => {
          return { key: bank.bankCode, value: bank.bankName };
        }) || []
      );
    }
    return [];
  }, [banksData]);

  const providerData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data || [];
    }
    return [];
  }, [data]);

  const initialValues = useMemo(() => {
    return {
      vendor: providerData?.vendor,
      monnifyBankCodes: providerData?.monnifyBankCodes || [],
    };
  }, [providerData]);

  const validationSchema = () => {
    return yup.object({
      vendor: yup.string().required("Vendor is required"),
    });
  };

  const onSubmit = async (values) => {
    let payload;

    if (values.vendor !== "SPLIT") {
      payload = {
        vendor: values.vendor,
      };
    } else {
      payload = {
        ...values,
      };
    }

    setLoading(true);

    const { status, errorMessage } =
      await WalletController.setNGNProviders(payload);

    if (status === constant.Success) {
      MimaToastUtil.success({ message: "Payment Provider successfully set" });
      setLoading(false);
      return;
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };

  return (
    <div className={styles.aside}>
      <MimaText variant="subtitleBold" mb={3} color="var(--color-sell-main)">
        Set Transfer Provider
      </MimaText>
      {isLoading || banksData?.isLoading ? (
        <PageLoader />
      ) : (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            values,
            errors,
            touched,
          }) => (
            <>
              <MimaDropdown
                placeholder="Select Vendor"
                name="Payment Vendor"
                labelTitle="vendor"
                value={values.vendor}
                currentValue={values.vendor}
                onBlur={handleBlur}
                onChange={(data) => {
                  setFieldValue("vendor", data.key);
                }}
                data={["SPLIT", "MONNIFY", "PAYSTACK"]?.map((x) => ({
                  key: x,
                  value: x,
                }))}
                error={errors.vendor}
                touched={touched.vendor}
              />

              {values.vendor === "SPLIT" ? (
                <MimaMultiDropdown
                  labelTitle="Set Banks via Monnify"
                  name="monnifyBankCodes"
                  id="monnifyBankCodes"
                  value={values.monnifyBankCodes}
                  placeholder="Select Broadcast Channel"
                  currentValue={values.monnifyBankCodes}
                  onChange={(data) => {
                    setFieldValue("monnifyBankCodes", data);
                  }}
                  data={banks}
                  touched={touched.monnifyBankCodes}
                  error={errors.monnifyBankCodes}
                  width={38}
                />
              ) : (
                ""
              )}

              <MimaButton
                title="Save Provider"
                onClick={() => {
                  handleSubmit();
                }}
                width={38}
                loading={loading}
              />
            </>
          )}
        </Formik>
      )}
    </div>
  );
};

export default Provider;
